module.exports = __webpack_public_path__ + "a97b36e84118cdf617d96b3338182518.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./~/ace-builds/src-noconflict/snippets/turtle.js
// module id = 1452
// module chunks = 0